import React from 'react';
import PropTypes from 'prop-types';

const MainContainer = ({
  children,
  className = '',
  maxWidth = '4xl', // Options: sm, md, lg, xl, 2xl, 3xl, 4xl, 5xl, 6xl, 7xl, full
  padding = '4',
  rounded = 'lg',
  shadow = 'md',
  bgColor = 'white',
  animate = false
}) => {
  // Configure max-width classes
  const maxWidthClasses = {
    'sm': 'max-w-sm',
    'md': 'max-w-md',
    'lg': 'max-w-lg',
    'xl': 'max-w-xl',
    '2xl': 'max-w-2xl',
    '3xl': 'max-w-3xl',
    '4xl': 'max-w-4xl',
    '5xl': 'max-w-5xl',
    '6xl': 'max-w-6xl',
    '7xl': 'max-w-7xl',
    'full': 'max-w-full'
  };

  // Configure padding classes
  const paddingClasses = {
    '0': 'p-0',
    '1': 'p-1',
    '2': 'p-2',
    '4': 'p-4',
    '6': 'p-6',
    '8': 'p-8',
    '12': 'p-12'
  };

  // Configure rounded corner classes
  const roundedClasses = {
    'none': 'rounded-none',
    'sm': 'rounded-sm',
    'md': 'rounded-md',
    'lg': 'rounded-lg',
    'xl': 'rounded-xl',
    'full': 'rounded-full'
  };

  // Configure shadow classes
  const shadowClasses = {
    'none': 'shadow-none',
    'sm': 'shadow-sm',
    'md': 'shadow-md',
    'lg': 'shadow-lg',
    'xl': 'shadow-xl',
    '2xl': 'shadow-2xl'
  };

  // Configure background color classes
  const bgColorClasses = {
    'white': 'bg-white',
    'gray-50': 'bg-gray-50',
    'gray-100': 'bg-gray-100',
    'blue-50': 'bg-blue-50',
    'green-50': 'bg-green-50',
    'red-50': 'bg-red-50',
    'yellow-50': 'bg-yellow-50',
    'transparent': 'bg-transparent'
  };

  // Animation classes
  const animationClass = animate ? 'transition-all duration-300 ease-in-out' : '';

  // Compile all the classes
  const containerClasses = `
    ${maxWidthClasses[maxWidth] || maxWidthClasses['4xl']}
    ${paddingClasses[padding] || paddingClasses['4']}
    ${roundedClasses[rounded] || roundedClasses['lg']}
    ${shadowClasses[shadow] || shadowClasses['md']}
    ${bgColorClasses[bgColor] || bgColorClasses['white']}
    ${animationClass}
    mx-auto
    w-full
    ${className}
  `;

  return (
    <div className={containerClasses.trim()}>
      {children}
    </div>
  );
};

MainContainer.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  maxWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl', 'full']),
  padding: PropTypes.oneOf(['0', '1', '2', '4', '6', '8', '12']),
  rounded: PropTypes.oneOf(['none', 'sm', 'md', 'lg', 'xl', 'full']),
  shadow: PropTypes.oneOf(['none', 'sm', 'md', 'lg', 'xl', '2xl']),
  bgColor: PropTypes.oneOf(['white', 'gray-50', 'gray-100', 'blue-50', 'green-50', 'red-50', 'yellow-50', 'transparent']),
  animate: PropTypes.bool
};

export default MainContainer;